 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"account":"account","basket":"basket","carousel":"carousel","checkout":"checkout","cms-icons":"cms-icons","common":"common","content":"content","controls":"controls","gtm":"gtm","product":"product","product-configurator":"product-configurator","product-search":"product-search","public-icons-c":"public-icons-c","public-icons-p":"public-icons-p","public-icons-s":"public-icons-s","public-icons-a":"public-icons-a","public-icons-d":"public-icons-d","public-icons-t":"public-icons-t","public-icons-h":"public-icons-h","public-icons-l":"public-icons-l","public-icons-r":"public-icons-r","public-icons-w":"public-icons-w","public-icons-e":"public-icons-e","public-icons-i":"public-icons-i","public-icons-m":"public-icons-m","public-icons-u":"public-icons-u","public-icons-f":"public-icons-f","public-icons-v":"public-icons-v","public-icons-z":"public-icons-z","base-layout":"base-layout","storeclerk":"storeclerk","video-player":"video-player"}[chunkId]||chunkId) + "." + {"account":"a5f64821","basket":"37656b79","carousel":"6251583f","checkout":"7c2fdbf2","cms-icons":"37aa7c2e","common":"119ae3a0","content":"d1b1936a","controls":"fe36936d","gtm":"f0d81d85","product":"eafbc211","product-configurator":"42ea6a12","product-search":"6cf3f656","public-icons-c":"ac9c8ee0","public-icons-p":"1108a8c2","public-icons-s":"96b87279","public-icons-a":"d36ed959","public-icons-d":"a0a74b78","public-icons-t":"5db1de4b","public-icons-h":"6156e5a0","public-icons-l":"d41eb79c","public-icons-r":"8262dec2","public-icons-w":"650a3a78","public-icons-e":"88b749ba","public-icons-i":"6b5e807d","public-icons-m":"4a1b642f","public-icons-u":"4beda88a","public-icons-f":"9d98f0ef","public-icons-v":"4b558166","public-icons-z":"4f8bcf0e","base-layout":"31cc6422","storeclerk":"764787bb","video-player":"9266d055"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account":1,"basket":1,"carousel":1,"checkout":1,"cms-icons":1,"common":1,"content":1,"controls":1,"product":1,"product-configurator":1,"product-search":1,"base-layout":1,"storeclerk":1,"video-player":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"account":"account","basket":"basket","carousel":"carousel","checkout":"checkout","cms-icons":"cms-icons","common":"common","content":"content","controls":"controls","gtm":"gtm","product":"product","product-configurator":"product-configurator","product-search":"product-search","public-icons-c":"public-icons-c","public-icons-p":"public-icons-p","public-icons-s":"public-icons-s","public-icons-a":"public-icons-a","public-icons-d":"public-icons-d","public-icons-t":"public-icons-t","public-icons-h":"public-icons-h","public-icons-l":"public-icons-l","public-icons-r":"public-icons-r","public-icons-w":"public-icons-w","public-icons-e":"public-icons-e","public-icons-i":"public-icons-i","public-icons-m":"public-icons-m","public-icons-u":"public-icons-u","public-icons-f":"public-icons-f","public-icons-v":"public-icons-v","public-icons-z":"public-icons-z","base-layout":"base-layout","storeclerk":"storeclerk","video-player":"video-player"}[chunkId]||chunkId) + "." + {"account":"9c7ca4de","basket":"81d44c87","carousel":"36672437","checkout":"cae4f224","cms-icons":"14e50db4","common":"f2e9cf6c","content":"a0947e51","controls":"461b01b8","gtm":"31d6cfe0","product":"14076eb7","product-configurator":"9cd67d26","product-search":"8309856d","public-icons-c":"31d6cfe0","public-icons-p":"31d6cfe0","public-icons-s":"31d6cfe0","public-icons-a":"31d6cfe0","public-icons-d":"31d6cfe0","public-icons-t":"31d6cfe0","public-icons-h":"31d6cfe0","public-icons-l":"31d6cfe0","public-icons-r":"31d6cfe0","public-icons-w":"31d6cfe0","public-icons-e":"31d6cfe0","public-icons-i":"31d6cfe0","public-icons-m":"31d6cfe0","public-icons-u":"31d6cfe0","public-icons-f":"31d6cfe0","public-icons-v":"31d6cfe0","public-icons-z":"31d6cfe0","base-layout":"c8d577f7","storeclerk":"a094b891","video-player":"098d7109"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/Frontend/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"bootstrap-vue-components","bootstrap-vue-icons","date-fns","lodash","popper","vue-dist","vuex","bootstrap-vue","chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
